import { useEffect, useState } from "react";
import { db, loggedGetDoc } from "../firebase";
import { doc, setDoc } from "firebase/firestore";

export interface NatureField {
  name: string;
  label: string;
  required?: boolean;
  requiredIf?: string;
  visibleIfRole?: string;
  visibleIfNature?: string;
}

export interface NatureConfig {
  label: string;
  fields: NatureField[];
}

export function useNatureConfig(nature: string) {
  const [config, setConfig] = useState<NatureConfig | null>(null);

  useEffect(() => {
    let ignore = false;
    async function fetch() {
      try {
        const snap = await loggedGetDoc(doc(db, "natureConfigs", nature));
        if (!ignore) {
          if (snap.exists()) setConfig(snap.data() as NatureConfig);
          else setConfig(null);
        }
      } catch (e) {
        console.warn("Failed to load nature config", e);
      }
    }
    if (nature) fetch();
    return () => {
      ignore = true;
    };
  }, [nature]);

  const saveConfig = async (data: NatureConfig) => {
    await setDoc(doc(db, "natureConfigs", nature), data, { merge: true });
    setConfig(data);
  };

  return { config, saveConfig };
}
